import { SentEmailsCounter } from '../SentEmailsCounter'
import { CreditBalance } from './components/CreditBalance'
import { CurrentPlan } from './components/CurrentPlan'

interface Props {
  counters: uui.domain.server.CountryNotificationCounters
  subscription: uui.domain.server.SmsSubscription
}

export function PlanDetails(props: Props) {
  const { counters, subscription } = props

  const { emailCountStartTs, emailCount, smsCount, callCredits } = counters

  const {
    expiryTs,
    plan: { smsCount: smsLimit, allowSmsOverage, trial, name, durationMonths },
  } = subscription

  const emailStartDate = new Date(emailCountStartTs)
  const smsPlanExpireDate = new Date(expiryTs)

  return (
    <>
      <CurrentPlan planName={name} expireDate={smsPlanExpireDate} durationMonths={durationMonths} />

      <CreditBalance
        smsLimit={smsLimit}
        smsCount={smsCount}
        callCredits={callCredits}
        allowSmsOverage={allowSmsOverage}
        trial={trial}
      />

      <SentEmailsCounter startDate={emailStartDate} emailCount={emailCount} />
    </>
  )
}
